import { cloneDeep } from 'lodash';
import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { BaseUI } from '../../base.ui';
import { FatcaManager, FatcaManagerCompany } from '../../../domain/data';
import { ParentEvents } from '../../../utils/parent-events.service';

let nextUniqueId = 0;

@Component({
    selector: 'thr-full-data-form-company',
    templateUrl: './full-data-form-company.component.html',
    styleUrls: ['./full-data-form-company.component.scss']
})
export class FullDataFormCompanyComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public prefix: string;
    public adding = false;
    public editing = false;
    public currentCompany: FatcaManagerCompany;

    @Input()
    manager: FatcaManager;

    @Input()
    isDisabled = false;


    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngOnInit() {
        this.prefix = `tfcomp-${nextUniqueId++}-`;

        if (this.manager.companies.length === 0) {
            this.onAdd();
        }
    }

    onAdd() {
        this.currentCompany = new FatcaManagerCompany();
        this.adding = true;
        this.editing = false;
    }

    onSave() {
        if (this.adding) {
            this.manager.addCompany(this.currentCompany);
        } else if (this.editing) {
            this.manager.updateCompany(this.currentCompany);
        }

        this.onCancel();
    }

    onCancel() {
        this.adding = false;
        this.editing = false;
        this.currentCompany = undefined;

        this.parentEvents.resize();
    }

    onEdit(company: FatcaManagerCompany) {
        this.currentCompany = cloneDeep(company);
        this.editing = true;
        this.adding = false;
    }

    onRemove(company: FatcaManagerCompany) {
        this.manager.removeCompany(company);

        if (this.currentCompany && this.currentCompany.id.value === company.id.value) {
            this.onCancel();
        }

        if (!this.adding && this.manager.companies.length === 0) {
            this.onAdd();
        }

        this.parentEvents.resize();
    }
}
